// create modal for attachment in po list
import React from "react";
import { Modal, Button } from "react-bootstrap";

class AttachmentModal extends React.Component {
  render() {
    const { show, onHide, poDetails } = this.props;
    const poId =
      poDetails && poDetails.po_number ? poDetails.po_number : poDetails.id;
    const files = poDetails && poDetails.files ? poDetails.files : [];

    const getFileUrl = (file) => {
      if (!file) {
        return "";
      }
      if (typeof file === "string") {
        return file;
      }
      return file.url || "";
    };

    const getFileName = (file, index) => {
      if (file && file.name) {
        return file.name;
      }
      const url = getFileUrl(file);
      if (url) {
        const parts = url.split("/");
        return parts[parts.length - 1] || `Attachment ${index + 1}`;
      }
      return `Attachment ${index + 1}`;
    };

    const getFileType = (file) => {
      const name = getFileName(file, 0);
      const parts = name.split(".");
      if (parts.length > 1) {
        return parts[parts.length - 1].toUpperCase();
      }
      return "FILE";
    };

    const getFileIcon = (file) => {
      const type = getFileType(file);
      if (type === "PDF") {
        return "fa-file-pdf-o";
      }
      if (["PNG", "JPG", "JPEG", "GIF", "WEBP"].includes(type)) {
        return "fa-file-image-o";
      }
      if (["DOC", "DOCX"].includes(type)) {
        return "fa-file-word-o";
      }
      if (["XLS", "XLSX", "CSV"].includes(type)) {
        return "fa-file-excel-o";
      }
      return "fa-paperclip";
    };

    return (
      <Modal show={show} onHide={onHide} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Attachments for PO {poId ? `#${poId}` : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="text-muted"
            style={{ marginBottom: "12px", fontSize: "13px" }}
          >
            Review and open the uploaded files below.
          </div>
          {files.length > 0 ? (
            <div className="list-group">
              {files.map((file, index) => (
                <a
                  key={index}
                  href={getFileUrl(file)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                  style={{
                    wordBreak: "break-word",
                    borderRadius: "12px",
                    marginBottom: "10px",
                    border: "1px solid #e2e8f0",
                    background:
                      "linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%)",
                    paddingTop: "14px",
                    paddingBottom: "14px",
                    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.05)",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      minWidth: 0,
                    }}
                  >
                    <span
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        background: "#eef4ff",
                        color: "#2457d6",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "15px",
                        fontWeight: 700,
                        flex: "0 0 auto",
                      }}
                    >
                      <i
                        className={`fa ${getFileIcon(file)}`}
                        aria-hidden="true"
                      />
                    </span>
                    <span style={{ minWidth: 0, display: "block" }}>
                      <span
                        style={{
                          display: "block",
                          fontWeight: 600,
                          color: "#1f2937",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {getFileName(file, index)}
                      </span>
                      <span
                        style={{
                          display: "block",
                          marginTop: "2px",
                          color: "#6b7280",
                          fontSize: "12px",
                        }}
                      >
                        Attachment {index + 1}
                      </span>
                    </span>
                  </span>
                </a>
              ))}
            </div>
          ) : (
            <div
              className="text-center text-muted py-4"
              style={{
                border: "1px dashed #d8e0ea",
                borderRadius: "12px",
                background: "#fcfdff",
              }}
            >
              <div style={{ fontWeight: 600, color: "#475569" }}>
                No attachments available
              </div>
              <div style={{ marginTop: "4px", fontSize: "13px" }}>
                This purchase order has no uploaded files yet.
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default AttachmentModal;
